import React from 'react';

export const SmartLoader = ({ active, text, opaque, style }) => {
  const activeLoader = active ? 'active' : '';
  const opaqueClass = opaque && active ? 'opaque' : '';
  const defaultStyles = {
    loader: {},
    ball: {},
    text: {}
  };
  const styles = style ? style : defaultStyles;

  return (
    <div id="smart-loader" className={`smart-loader ${activeLoader} ${opaqueClass}`} style={styles.loader}>
      <div className={`loader ${activeLoader}`}>
        <div className="container">
          <div className={'loader-inner ball-pulse-sync'}>
            <div style={styles.ball} />
            <div style={styles.ball} />
            <div style={styles.ball} />
          </div>
          <div className={'loader-text'} style={styles.text}>
            {text}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartLoader;
